import { GlLink } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'LinkCell',
    mixins: [
        glListenersMixin,
        glSlotsMixin
    ],
    props: {
        href: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        component () {
            if (this.href) {
                return GlLink;
            }
            return 'span';
        }
    }
};
